module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAABJklEQVQoU42SsUrEQBCGZ28TslwixKSQTRYUsVBOEGyutLC00/LwFfRZtBYsrGzsfAh7bQU5MlHwTIpgEveyKwsKBzlNtpz9v5n5Z4ZwzieEkAB6PK31B+Gcn6dpetFDD0ZLoig6Q8TLPoDR/glsCHHwpdQeBXibIt6ahC3Add01SulKEATv87o+/KzrB8bY8W8HLcAELMt6VVLOAYD0Aqqquhs6zti00AnEnJ8CQEht+9EAjZS7ADBL0vRmqYeuSbU8xHF8pLXeXAQJIc9JktwvreD7/rqUctV82rad5Xn+sgi3KnieNzIefkSzoiiewjDcZoxtmZhumv3OTQshTsqynA4dx1dajzpvyQBUykxSuoOI10RwPlH/XatSAQwGGSJemdV8A/i0p5yfgRa1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/List/icon-report-gray.png
// module id = 1469
// module chunks = 0